import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {ConfirmationDialogResult, YesNoDialogData, YesNoDialogResult} from '@portal-workspace/grow-shared-library';
import {FormBuilder} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';

@Component({
    templateUrl: './yes-no.dialog.html',
    styleUrls: ['./yes-no.dialog.scss'],
    standalone: true,
    imports: [FlexModule, MatButtonModule, MatDialogModule]
})
export class YesNoDialog {

  constructor(@Inject(MAT_DIALOG_DATA) public data: YesNoDialogData,
              private dialogRef: MatDialogRef<YesNoDialog, YesNoDialogResult>,
              private formBuilder: FormBuilder) {

  }

  onSubmit(readyForSubmission: boolean) {
    const result: ConfirmationDialogResult = { readyForSubmission: readyForSubmission };
    this.dialogRef.close(result);
  }

}
